<div class="row g-0 services-nav-card">
  <!-- Close button -->
  <button type="button" class="btn-close position-absolute m-3" aria-label="Close" (click)="closeCard()">
  </button>

  <!-- Left Side - Header Text -->
  <div class="col-md-3 p-4 services-nav-bg d-flex flex-column justify-content-start">
    <h2 class="text-orange fs-4 fw-bold mb-3">Services And Solutions Built Specifically For Your Business</h2>
    <p class="text-gray small mb-0">
      We're proud to share that Kalpita Technology has helped featured among the best outsourcing service providers, a
      recognition that highlights our commitment to delivering exceptional service, innovation, and value to our
      clients.
    </p>
  </div>

  <!-- Right Side - Grid -->
  <div class="col-md-9 p-4 bg-white">
    <div class="row">

      <!-- Services Block (2 cols) -->
      <div class="col-12 col-md-6">
        <div class="text-left mb-3">
          <h5 class="fw-bold text-dark">Services</h5>
        </div>
        <div class="row">
          <div class="col-6">
            <ul class="list-unstyled">
              <li><a href="javascript:void(0)" class="dropdown-item"
                  (click)="navigateTo('company-services/custom-software-development')">Custom Software Development</a></li>
              <li><a href="javascript:void(0)" class="dropdown-item"
                  (click)="navigateTo('company-services/mobile-app-development')">Mobile App Development</a></li>
              <li><a href="javascript:void(0)" class="dropdown-item"
                  (click)="navigateTo('company-services/web-development')">Web Development</a></li>
              <li><a href="javascript:void(0)" class="dropdown-item"
                  (click)="navigateTo('company-services/ui-ux-design')">UI/UX Design</a></li>
              <li><a href="javascript:void(0)" class="dropdown-item"
                  (click)="navigateTo('company-services/it-consulting')">IT Consulting</a></li>
            </ul>
          </div>
          <div class="col-6">
            <ul class="list-unstyled">
              <li><a href="javascript:void(0)" class="dropdown-item"
                  (click)="navigateTo('company-services/digital-marketing')">Digital Marketing</a></li>
              <li><a href="javascript:void(0)" class="dropdown-item"
                  (click)="navigateTo('company-services/testing-qa')">Testing & QA</a></li>
              <!-- <li><a href="javascript:void(0)" class="dropdown-item"
                  (click)="navigateTo('company-services/software-development')">IT Consulting</a></li> -->
              <li><a href="javascript:void(0)" class="dropdown-item"
                  (click)="navigateTo('company-services/ai-as-a-service')">AI as a Service</a></li>
              <li><a href="javascript:void(0)" class="dropdown-item"
                  (click)="navigateTo('company-services/data-engineering')">Data Engineering</a></li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Industries Block (2 cols) -->
      <div class="col-12 col-md-6">
        <div class="text-left mb-3">
          <h5 class="fw-bold text-dark">Industries</h5>
        </div>
        <div class="row">
          <div class="col-6">
            <ul class="list-unstyled">
              <li><a href="javascript:void(0)" class="dropdown-item"
                  (click)="navigateTo('industries/insurtech')">Insurtech</a></li>
              <li><a href="javascript:void(0)" class="dropdown-item"
                  (click)="navigateTo('industries/healthtech')">Healthtech</a></li>
              <li><a href="javascript:void(0)" class="dropdown-item"
                  (click)="navigateTo('industries/fintech')">Fintech</a></li>
              <li><a href="javascript:void(0)" class="dropdown-item"
                  (click)="navigateTo('industries/hitech')">Hi-Tech</a></li>
              <li><a href="javascript:void(0)" class="dropdown-item"
                  (click)="navigateTo('industries/ecommerce')">E-commerce</a></li>
              <li><a href="javascript:void(0)" class="dropdown-item"
                  (click)="navigateTo('industries/media-entertainment')">Media & Entertainment</a></li>
              <li><a href="javascript:void(0)" class="dropdown-item"
                  (click)="navigateTo('industries/edtech')">Ed-Tech</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>